import type { AssessmentResultStore } from './interfaces'

export const actions = {
  setLoading (this: AssessmentResultStore, payload: AssessmentResultStore['loading']): void {
    this.loading = payload
  },
  setQuestions (this: AssessmentResultStore, payload: AssessmentResultStore['questions']): void {
    this.questions = payload
  },
  setComprehension (this: AssessmentResultStore, payload: AssessmentResultStore['comprehension']): void {
    this.comprehension = payload
  },
  setScore (this: AssessmentResultStore, payload: AssessmentResultStore['score']): void {
    this.score = payload
  },
  setVariant (this: AssessmentResultStore, payload: AssessmentResultStore['variant']): void {
    this.variant = payload
  },
  setAssessmentId (this: AssessmentResultStore, payload: AssessmentResultStore['id']): void {
    this.id = payload
  },
  setAssessmentUrls (this: AssessmentResultStore, payload: AssessmentResultStore['assessmentUrls']): void {
    this.assessmentUrls = payload
  },
}
